import { render } from "./StoreCategorySidebar.vue?vue&type=template&id=0c5e842d&scoped=true"
import script from "./StoreCategorySidebar.vue?vue&type=script&lang=js"
export * from "./StoreCategorySidebar.vue?vue&type=script&lang=js"

import "./StoreCategorySidebar.vue?vue&type=style&index=0&id=0c5e842d&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5e842d"]])

export default __exports__